export enum TrialInsightInvestigatorCostKey {
  INVESTIGATOR = 'investigator',
}

export enum TrialInsightPatientEnrolledKey {
  PATIENT_ENROLLED = 'patientEnrolled',
}

export enum TrialInsightsBvaChartKey {
  CHART = 'chart',
}

export enum TrialInsightsPatientCostKey {
  GROUP = 'group',
  SITE = 'site',
}

export enum TrialInsightsPaymentMilestoneKey {
  MILESTONES = 'milestones',
}

export enum TrialInsightsRemainingSpendKey {
  REMAINING_SPEND = 'remainingSpend',
}

export enum TrialInsightsScreenFailKey {
  NUMBER = 'number',
  PERCENT = 'percent',
}

export enum TrialInsightsSiteCostKey {
  LAG = 'lag',
  SPEND = 'spend',
}

export type TrialInsightsTableButtonData = {
  key: string;
  value: string;
};

export type TrialInsightsTableButtonOptions = {
  data: TrialInsightsTableButtonData[];
  defaultButtonKey: string;
  display: boolean;
};

export type TrialInsightsTableChangeKeyFn = {
  (buttonKey: string): void;
};

export type TrialInsightsTableHeaderData = {
  buttonKey: string;
  leftValue: string;
  rightValue: string;
};

export type TrialInsightsTableHeaderOptions = {
  data: TrialInsightsTableHeaderData[];
  display: boolean;
};

export type TrialInsightsTableLinkOptions = {
  display: boolean;
  url: string;
  value: string;
};

export interface TrialInsightsTableModel {
  createTable?: () => TrialInsightsTableOptions;
  route: string;
  subRoute: string;
}

export type TrialInsightsTableOptions = {
  buttons: TrialInsightsTableButtonOptions;
  header: TrialInsightsTableHeaderOptions;
  link: TrialInsightsTableLinkOptions;
  rowData: TrialInsightsTableRowDataOptions;
};

export type TrialInsightsTableRowData = {
  buttonKey: string;
  color?: string;
  leftHeader: string;
  leftSubheader: string;
  rightHeader: string;
  rightSubheader: string;
};

export type TrialInsightsTableRowDataOptions = {
  compact: boolean;
  data: TrialInsightsTableRowData[];
};

export type TrialInsightsTableToggleOrderFn = {
  (): void;
};
